import React from "react";
import "./styles/Skeleton.css";

/**
 * Skeleton - A single shimmering placeholder bar.
 * @param {Object} props
 * @param {string} props.variant - 'text' | 'title' | 'circle'
 * @param {string|number} props.width - CSS width, e.g. "60%" or 120
 * @param {string|number} props.height - CSS height
 */
export const Skeleton = ({ variant = "text", width, height, style }) => (
  <span
    className={`dsSkeleton ${variant}`}
    style={{ width, height, ...style }}
    aria-hidden="true"
  />
);

/**
 * MetricsSkeleton - Placeholder for a row of MetricCards.
 * @param {number} props.count - How many cards to draw
 */
export const MetricsSkeleton = ({ count = 4 }) => (
  <div className="dsSkeletonMetrics">
    {Array.from({ length: count }).map((_, i) => (
      <div className="dsSkeletonMetric" key={i}>
        <Skeleton width="45%" />
        <Skeleton variant="title" width="30%" />
      </div>
    ))}
  </div>
);

/**
 * TableSkeleton - Placeholder shaped like the data panel it replaces.
 * @param {number} props.rows - How many rows to draw
 * @param {number} props.columns - How many cells per row
 */
export const TableSkeleton = ({ rows = 6, columns = 5 }) => (
  <div className="dsSkeletonTable" role="status" aria-label="Loading">
    <div className="dsSkeletonTableHeader" />
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div className="dsSkeletonRow" key={rowIndex}>
        {Array.from({ length: columns }).map((__, cellIndex) => (
          <Skeleton key={cellIndex} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
